import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postPresence = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `/monitoring-operator/presences/clock-in`,
    data: payload,
  });

  return data?.data;
};

export default postPresence;
